import { useEffect, useState } from 'react';
import Spinner from '../../reusable/spinner/spinner.component';
import Client from '../../../tools/client';

import {
  FieldSection,
  FieldGroup,
  Label,
  Description,
  Input,
  Toggle,
  ButtonRow,
  Button
} from '../../configuration/sections/configuration-sections.styles';

const client = new Client();

const IntegrationConfigurationDisplay = ({ integration, initialConfig = {}, onUpdate }) => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});

    useEffect(() => {
    if (!integration) return;

    const sameKeys = Object.keys(initialConfig).every(key => form[key] === initialConfig[key]);

    if (!sameKeys) {
        setForm(initialConfig);
    }

    setLoading(false);
    }, [integration?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleToggle = (key) => {
    setForm({ ...form, [key]: !form[key] });
  };

  const handleSave = async () => {
    try {
      await client.updateIntegration({
        integrationId: integration.id,
        configuration: form
      });

      setEditing(false);
      onUpdate?.();
    } catch (err) {
      console.error('Failed to update integration config:', err);
    }
  };

  if (loading) return <Spinner />;

  return (
    <FieldSection>
      {Object.entries(form).map(([key, value]) => (
        <FieldGroup key={key}>
          <Label htmlFor={key}>{key}</Label>
          {typeof value === 'boolean' ? (
            <Toggle>
              <input
                type="checkbox"
                checked={value}
                onChange={() => handleToggle(key)}
                disabled={!editing}
              />
              <span />
            </Toggle>
          ) : (
            <Input
              id={key}
              name={key}
              value={value}
              onChange={handleChange}
              disabled={!editing}
            />
          )}
        </FieldGroup>
      ))}

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </FieldSection>
  );
};

export default IntegrationConfigurationDisplay;